"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _state = _interopRequireDefault(require("@/libs/state"));

var _default = {
  data: function data() {
    return {
      closing: false
    };
  },
  computed: {
    backgroundStyle: function backgroundStyle() {
      var style = {};
      var options = _state.default.settings.startupOptions;

      if (options.infoBackground) {
        style['background-image'] = "url(".concat(options.infoBackground, ")");
      }

      return style;
    },
    backgroundImage: function backgroundImage() {
      return _state.default.settings.startupOptions.infoBackground || '';
    },
    infoContent: function infoContent() {
      return _state.default.settings.startupOptions.infoContent || '';
    }
  },
  methods: {
    close: function close() {
      var _this = this;

      this.closing = true;

      var startApp = function startApp(event) {
        _this.$el.removeEventListener('transitionend', startApp);

        _state.default.persistence.watchStateForChanges(); // Hacky to be using $parent but this component should only be used in a sepcific
        // scope within startup screens


        _this.$parent.$emit('start');
      };

      this.$el.addEventListener('transitionend', startApp, false);
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CommonLayout"]
window._kiwi_exports.components.startups.CommonLayout = exports.default ? exports.default : exports;
